module.exports = __webpack_public_path__ + "static/media/USGold-Introduction-to-the-USG-Token.8fb16f94.pdf";